import { createAction } from "@reduxjs/toolkit";
import {
  forgotPasswordSendEmailActionTypes,
  forgotPasswordActionTypes,
  forgotPasswordRestoreActionTypes,
  forgotPasswordModalType,
} from "./actionTypes";

export const forgotPasswordSendEmail = createAction(
  forgotPasswordSendEmailActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const forgotPasswordSendEmailSuccess = createAction(
  forgotPasswordSendEmailActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const forgotPasswordSendEmailFailure = createAction(
  forgotPasswordSendEmailActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const forgotPasswordRestore = createAction(
  forgotPasswordRestoreActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const forgotPasswordRestoreSuccess = createAction(
  forgotPasswordRestoreActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const forgotPasswordRestoreFailure = createAction(
  forgotPasswordRestoreActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const forgotPasswordReset = createAction(
  forgotPasswordActionTypes.reset,
);

export const toggleForgotPasswordModal = createAction(forgotPasswordModalType);
